import classnames from 'classnames'
import axios from 'axios'
import { Component } from 'preact'
import { instantiatePreactComponents } from '../../libs/preact-entry'
import Phrase from '../../libs/translationsUtils/phrase'
import globals from '../../utils/globals'

interface Props {
  url: string
}

interface State {
  embedCode: string
  hasError: boolean
  hasAccess: boolean
}

class OEmbed extends Component<Props> {
  private ref: HTMLDivElement | null = null

  constructor() {
    super()
    this.state = {
      embedCode: '',
      hasError: false,
      hasAccess: false
    }
  }

  componentDidMount() {
    axios
      .get('/oembed/getembeddedUrl?url=' + this.props.url)
      .then((res) => {
        this.setState({ embedCode: res.data.html.replace('http://', 'https://'), hasAccess: true })
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          this.setState({ hasError: true })
        } else {
          this.setState({ hasError: true, hasAccess: true })
        }
      })
  }

  componentDidUpdate() {
    if (this.ref) {
      instantiatePreactComponents(this.ref)
    }
  }

  render(props: Props, state: State) {
    let isEmbedTopicCard

    try {
      const embedUrl = new URL(props.url)
      isEmbedTopicCard = embedUrl.host === new URL(globals('communityUrl')).host
    } catch {
      isEmbedTopicCard = false
    }

    if (!state.hasAccess) {
      return (
        <a
          target='_blank'
          href={props.url}
          rel='noreferrer nofollow noopener'
          style={{ display: `${isEmbedTopicCard ? 'block' : 'inline'}` }}
        >
          {props.url}
        </a>
      )
    }
    if (state.hasError && isEmbedTopicCard) {
      return (
        <a
          target='_blank'
          href={props.url}
          rel='noreferrer nofollow noopener'
          style={{ display: 'block' }}
        >
          {props.url}
        </a>
      )
    }
    if (state.hasError) {
      return (
        <div className='oembed-wrapper'>
          <div className='box box__pad box--note'>
            <Phrase p='embeddable.not.available' />
          </div>
        </div>
      )
    }
    return (
      <div className='oembed-wrapper'>
        <div
          ref={(el) => {
            this.ref = el
          }}
          className={classnames({
            'oembed-iframe-wrapper': state.embedCode.includes('<iframe')
          })}
          dangerouslySetInnerHTML={{ __html: state.embedCode }}
        />
      </div>
    )
  }
}

export default OEmbed
